import { motion } from "framer-motion";

export default function Home() {
  const handleCallClick = () => {
    window.location.href = "tel:+491734317404";
  };

  return (
    <div id="home" className="relative w-full h-[100vh] max-h-[50em] overflow-hidden">
      <motion.img
        className="w-full h-full object-cover"
        src="./77.jpeg"
        alt="Global Bau Hero"
        initial={{ scale: 1.2 }}
        animate={{ scale: 1 }}
        transition={{ duration: 12, ease: "easeOut" }}
      />
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute flex flex-col gap-8 justify-center px-6 sm:px-10 md:px-20 inset-0">
        <motion.h1
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-bold leading-tight max-w-3xl"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Wir sind spezialisiert auf Herstellung von Bodenplatten und Kellern in
          Elementbauweise
        </motion.h1>
        <motion.p
          className="max-w-xl text-white/90 text-sm sm:text-base leading-relaxed"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          Wir sind spezialisiert auf Herstellung von Bodenplatten und Kellern in
          Elementbauweise. Wir mauern auch Ihr Eigenheim von Grund auf, nach
          Ihren Wünschen. Wir stellen Durchbrüche und Kernbohrungen jeder Größe
          her. Sämtliche Abbrucharbeiten werden von uns auch durchgeführt.
        </motion.p>
        <motion.button
          onClick={handleCallClick}
          className="self-start text-white px-8 py-3 bg-darkBlue rounded-lg hover:bg-blue-800 transition-colors font-medium"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          Kontakt
        </motion.button>
      </div>
    </div>
  );
}
